import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('es-ES', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function formatShortDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('es-ES', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}

export function getStatusColor(status) {
  const colors = {
    disponible: 'status-disponible',
    asignado: 'status-asignado',
    mantenimiento: 'status-mantenimiento',
    falla: 'status-falla',
    perdido: 'bg-red-600/20 text-red-400 border border-red-500/30',
    baja: 'status-baja'
  };
  return colors[status] || 'bg-gray-500/20 text-gray-400';
}

export function getStatusLabel(status) {
  const labels = {
    disponible: 'Disponible',
    asignado: 'Asignado',
    mantenimiento: 'Mantenimiento',
    falla: 'En Falla',
    perdido: 'Perdido',
    baja: 'Dado de Baja'
  };
  return labels[status] || status;
}

export function getMovementTypeColor(type) {
  const colors = {
    entrada: 'movement-entrada',
    salida: 'movement-salida',
    retorno: 'movement-retorno'
  };
  return colors[type] || 'bg-gray-500/20 text-gray-400';
}

export function getMovementTypeLabel(type) {
  const labels = {
    entrada: 'Entrada',
    salida: 'Salida',
    retorno: 'Retorno'
  };
  return labels[type] || type;
}

export function getRoleLabel(role) {
  const labels = {
    superadmin: 'Super Admin',
    admin: 'Administrador',
    supervisor: 'Supervisor',
    auditor: 'Auditor',
    almacenista: 'Almacenista',
    user: 'Usuario'
  };
  return labels[role] || role;
}

export function downloadFile(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
}

// User Activity Tracking
let activityApi = null;

export function setActivityApi(api) {
  activityApi = api;
}

export async function logUserActivity(actionType, action, element = null, details = null) {
  if (!activityApi) return;
  
  try {
    await activityApi().post('/activity/log', {
      action_type: actionType,
      action: action,
      page: window.location.pathname,
      element: element,
      details: details
    });
  } catch (error) {
    // Silently fail - don't interrupt user experience
    console.debug('Activity log failed:', error);
  }
}

// Convenience functions for common activity types
export const trackNavigation = (destination, menuLabel) => 
  logUserActivity('navigation', `Navegó a ${menuLabel || destination}`, 'menu', { destination });

export const trackClick = (element, description) => 
  logUserActivity('click', description, element);

export const trackFilter = (filterName, filterValue) => 
  logUserActivity('filter', `Filtró por ${filterName}: ${filterValue}`, 'filter', { filterName, filterValue });

export const trackDownload = (filename, type) => 
  logUserActivity('download', `Descargó ${type || 'archivo'}: ${filename}`, 'download', { filename, type });

export const trackAction = (action, entity, entityId = null) => 
  logUserActivity('action', action, entity, { entityId });

export const trackTabChange = (tabName) => 
  logUserActivity('tab_change', `Cambió a pestaña: ${tabName}`, 'tab');

export const trackModalOpen = (modalName) => 
  logUserActivity('modal', `Abrió modal: ${modalName}`, 'modal');

export const trackSearch = (searchTerm, context) => 
  logUserActivity('search', `Búsqueda: "${searchTerm}"`, context || 'search', { searchTerm });

